import { jsx as _jsx } from "react/jsx-runtime";
import { Analytics } from "@biocentury/core";
import { Product } from "@biocentury/core/types";
import AuthContext from "@contexts/auth-context";
import { getSignInURL } from "@utils/helpers/url";
import router from "next/router";
import React, { useContext, useEffect, useState } from "react";
var LoginLink = function(param) {
    var _classNames = param.classNames, classNames = _classNames === void 0 ? "uppercase bold text-center cursor-pointer hover:underline text-sm" : _classNames, _title = param.title, title = _title === void 0 ? "SIGN IN" : _title;
    var ref = useState(window.location.href), pageUrl = ref[0], setPageUrl = ref[1];
    var currentUser = useContext(AuthContext);
    useEffect(function() {
        var handleRouteChange = function(url) {
            setPageUrl("".concat(process.env.NEXT_PUBLIC_APP_URL).concat(url));
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, []);
    if (currentUser) {
        return /*#__PURE__*/ _jsx("span", {});
    }
    return /*#__PURE__*/ _jsx("a", {
        onClick: function() {
            Analytics.WebUsage.track({
                action: "Click",
                category: getSignInURL(pageUrl),
                product: Product.Profiles
            });
        },
        className: classNames,
        href: getSignInURL(pageUrl),
        children: title
    });
};
export default LoginLink;
